import React from 'react';

import { ROLLUP_BRANCH_NUMBER, SITE_LIST_FIELDS } from './utils';
import { Button } from '../../components';

import './styles.scoped.css';

/**
 * CP-857: react-table column definitions for the SiteList grid.
 *
 * Lives outside the screen component (the same reason TableContents keeps buildColumns in
 * its utils) so the Cell renderers are not redefined on every render, which would remount
 * every cell as the user types in the filter.
 */

/**
 * Branch Number 1 is the reserved rollup row (AllDMS / AllDMSPT / AllFlex / AllMDS) — the
 * one row that is not a real operational branch, so it is marked in the grid.
 */
const ValueCell = ({ field, row }) =>
  field.key === 'BranchName' && String(row.original.BranchNumber) === String(ROLLUP_BRANCH_NUMBER) ? (
    <span>
      {row.original.BranchName}
      <span className="rollup-tag">rollup</span>
    </span>
  ) : (
    <span>{row.original[field.key]}</span>
  );

const RowActionsCell = ({ row, onEdit, onHistory }) => (
  <span className="row-actions">
    <Button variant="text" text="Edit" onPress={() => onEdit(row.original)} />
    <Button
      variant="text"
      text="History"
      onPress={() => onHistory({ BranchNumber: row.original.BranchNumber, LOB: row.original.LOB })}
    />
  </span>
);

export const buildColumns = ({ onEdit, onHistory }) => [
  ...SITE_LIST_FIELDS.map(field => ({
    // `Header` stays a plain string: TableFilter keys its dropdown by it and the screen
    // matches the chosen column by it, so a node here would break both. The full name
    // behind an abbreviation travels as `hint` and the screen renders it as the header's
    // tooltip.
    Header: field.label,
    hint: field.hint,
    accessor: field.key,
    Cell: ({ row }) => <ValueCell field={field} row={row} />,
  })),
  {
    Header: '',
    id: 'rowActions',
    disableSortBy: true,
    disableFilters: true,
    Cell: ({ row }) => <RowActionsCell row={row} onEdit={onEdit} onHistory={onHistory} />,
  },
];
